import React from "react";
import "../../../scss/dashboard/publicadas.css";
import NoFolderPic from "../../../images/dashboardAbogados/noFolder.svg";
import Plantilla from "../../../images/dashboardAbogados/Plantillas.svg";
function NoFoldersScreen({ width, text, img }) {
  return (
    <div
      className="noFolderScreen"
      style={{
        width: width,
      }}
    >
      <img src={NoFolderPic} alt="NoFolderPic" />

      <h2>{text}</h2>
    </div>
  );
}

export default NoFoldersScreen;
